import { uploadFile } from 'api/v2/upload';
import { createExpense, getExpenses } from 'api/v3/expenses';
import dayjs from 'dayjs';
import { UploadTypesEnum } from 'types/uploadEnums.types';

export const createExpenseDocument = (
  file: File,
  onProgress: (n: number) => void,
  options?: Record<string, any>,
) => {
  return uploadFile({
    file,
    onProgress,
    category: UploadTypesEnum.expense,
  }).then(({ key }: any) => createExpense(key, options?.isFake));
};

export const hasExpenses = (num?: number) =>
  getExpenses({ page: 1, perPage: 1, fields: '_id' }).then(
    ({ paging }) => paging.totalCount > (num || 0),
  );

export const hasUnpaidExpenses = () =>
  getExpenses({ page: 1, perPage: 1, fields: '_id', payment: 'unpaid' }).then(
    ({ paging }) => paging.totalCount > 0,
  );

export const hasOverdueExpenses = () =>
  getExpenses({ page: 1, perPage: 1, fields: '_id', payment: 'overdue' }).then(
    ({ paging }) => paging.totalCount > 0,
  );

export const firstExpense = () =>
  getExpenses({
    page: 1,
    perPage: 1,
    sort: 'created_asc',
  });

const vehiclesPurchaseYearKey = 'vehicles-purchase-year';
export const shouldShowVehiclePurchaseYearsModal = () => {
  const lastDate = localStorage.getItem(vehiclesPurchaseYearKey);
  return (
    !lastDate ||
    !dayjs(lastDate).isValid() ||
    dayjs(lastDate).add(1, 'week').isBefore(dayjs())
  );
};
export const updateVehiclesPurchaseYearModalDate = () => {
  localStorage.setItem(vehiclesPurchaseYearKey, dayjs().toString());
};

export const clearVehiclesPurchaseYearModalDate = () => {
  localStorage.removeItem(vehiclesPurchaseYearKey);
};
